import { useSelector } from 'react-redux';

import { MainInfoLayout } from '../../components/MainInfoLayout';
import { getObjectInfo } from '../../selectors/objectInfo';
import { SubtitleContainer } from '../Subtitle';
import { TitleContainer } from '../Title';
import { ObjectOverallRatingContainer } from '../ObjectOverallRatingContainer';
import { AggregatedScoresContainer } from '../AggregatedScoresContainer';

export function MainInfoContainer() {
  const { formattedObjectName } = useSelector(getObjectInfo);

  return (
    <MainInfoLayout
      newbuildingNameFormatted={formattedObjectName}
      title={<TitleContainer />}
      subtitle={<SubtitleContainer />}
      newbuildingRatings={<AggregatedScoresContainer />}
      newbuildingOverallRating={<ObjectOverallRatingContainer />}
    />
  );
}
